import styled from 'styled-components';

export const StyledFieldset = styled.fieldset`
  display: flex;
  justify-content: flex-start;
  margin-right: 1rem;
  gap: 1.25rem;
  width: 100%;
`;
